import React from 'react'

const JumbotronFooter = () => {
  return <div style={styles.footer} />
}

const styles = {
  footer: {
    height: '150px',
    backgroundColor: '#BC986A',
    width: '100%'
  }
}

export default JumbotronFooter
